<script>
import AudioPlayerWaveDiagram from './AudioPlayerWaveDiagram.vue';
import AudioPlayerTimelineHotspot from './AudioPlayerTimelineHotspot.vue';
import { totalSeconds } from '../variables.js';

export default {
  name: 'AudioPlayerTimeline',
  components: {
      AudioPlayerWaveDiagram,
      AudioPlayerTimelineHotspot
  },
  props: {
    value: Number,
    trackSlug: String,
    hotspots: Array | Boolean
  },
  methods: {
  },
  computed: {
    timeLineProgress() {
      return this.value / totalSeconds;
    }
  }
}
</script>

<template>
  <div class="timeline">
    <!-- wave diagram -->
    <audio-player-wave-diagram
      v-bind:trackSlug="trackSlug"
      v-bind:hotspots="hotspots"
      v-bind:progress="timeLineProgress"
    />

    <!-- hotspots -->
    <div class="timeline__hotspots" v-if="hotspots">
      <audio-player-timeline-hotspot 
        v-for="(hotspot, i) in hotspots" 
        v-bind:position="hotspot.position" 
        v-bind:duration="hotspot.duration" 
        v-bind:key="i" 
      />
    </div>
    
    <!-- time scale -->
    <ul class="timeline__scale">
      <li class="timeline__scale-item">0:00</li>
      <li class="timeline__scale-item">6:00</li>
      <li class="timeline__scale-item">12:00</li>
      <li class="timeline__scale-item">18:00</li>
      <li class="timeline__scale-item">23:59</li>
    </ul>

    <!-- slider -->
    <input 
      v-on:change="$emit('change', $event)" 
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      class="timeline__input"
      type="range" 
      min="0" max="86399">

  </div>
</template>

<style scoped lang="scss">
@import "../assets/styles/variables";

.timeline {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.timeline__scale {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
  margin: 0;
}

.timeline__scale-item {
  display: block;
  font-family: var(--font-family-secondary);
  color: var(--dark);
  opacity: .75;
}

.timeline__input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-appearance: none;
  background: transparent;
}

.timeline__input:focus {
  outline: none;
}

.timeline__input::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 2rem;
  height: 6rem;
}

.timeline__input::-webkit-slider-thumb:after {
  content: "";
  height: 100%;
  width: 0.125rem;
  color: var(--color-main);
}

.timeline__hotspots {
  position: absolute;
  bottom: 3rem;
  width: 100%;
  height: 1.3215rem;
}

.timeline__hotspot {
  position: static;
}

.wave-diagram {
  height: 100%;
  // margin: 0 1rem;
}

</style>
